import { graphql, useStaticQuery } from "gatsby";

export const fetchAllBrands = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpProductTag(filter: { count: { gte: 0 } }) {
        nodes {
          id
          count
          name
          slug
          description
          brandImages {
            tagImage {
              sourceUrl
              altText
            }
          }
        }
      }
    }
  `);

  return data.allWpProductTag.nodes;
};
